
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'
import functionsCatalogDetailDescriptor from './FunctionsCatalogDetailDescriptor.json'

export default defineComponent({
    name: 'functions-catalog-warning-dialog',
    components: { Dialog, Message },
    emits: ['close'],
    props: {
        visible: { type: Boolean },
        title: { type: String },
        missingFields: { type: Array }
    },
    data() {
        return {
            functionsCatalogDetailDescriptor
        }
    }
})
